/* eslint-disable class-methods-use-this */
// src/infrastructure/RankingRepository.js
import axios from 'axios';
import apiClient from './apiClient';

export class RankingRepository {
    async fetchLastSixMonthsEmissions(region) {
        const newApiClient = axios.create({
            baseURL: 'https://carbonemissions.smartbustw.com',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        try {
            const response = await newApiClient.get(`/api/v1/carbon-emissions/last-six-months-emissions/${region}`);

            if (!response.data || !Array.isArray(response.data)) {
                throw new Error('無效的碳排放數據');
            }

            return response.data.map(item => ({
                year: item.year,
                month: item.month,
                totalMileage: parseFloat(item.total_mileage) || 0,
                totalFuelConsumed: parseFloat(item.total_fuel_consumed) || 0,
                totalFuelExpense: parseFloat(item.total_fuel_expense) || 0,
                totalCarbonEmission: parseFloat(item.total_carbon_emission) || 0
            }));
        } catch (error) {
            console.error('Error fetching last six months emissions:', error);
            throw new Error('無法連接到碳排放數據服務');
        }
    }

    async fetchRankings(region) {
        try {
            const response = await apiClient.get(`/api/CarbonEmission/rankings/${region}`);
            if (response.data.code === 0 && response.data.success) {
                return response.data.data;
            }
            throw new Error(response.data.message || '獲取排名數據失敗');
        } catch (error) {
            console.error('Error fetching rankings:', error);
            throw new Error('無法連接到排名服務');
        }
    }

    async fetchMonthlyStats(region) {
        const newApiClient = axios.create({
            baseURL: 'https://carbonemissions.smartbustw.com',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        try {
            const response = await newApiClient.get(`/api/v1/carbon-emissions/monthly-stats/${region}`);

            if (!response.data) {
                throw new Error('無效的碳排放月度統計數據');
            }

            return {
                month: response.data.month,
                totalMileage: parseFloat(response.data.total_mileage) || 0,
                totalEmission: parseFloat(response.data.total_emission) || 0,
                emission_per_km: parseFloat(response.data.emission_per_km) || 0,
                emission_reduction_percentage: parseFloat(response.data.emission_reduction_percentage) || 0
            };
        } catch (error) {
            console.error('Error fetching monthly stats:', error);
            throw new Error('無法連接到碳排放月度統計服務');
        }
    }

    async fetchNewRankings(region) {
        const newApiClient = axios.create({
            baseURL: 'https://carbonemissions.smartbustw.com',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        try {
            const response = await newApiClient.get(`/api/v1/carbon-emissions/rankings/${region}`);
            const {
                mileage_rankings: mileageRankings,
                carbon_emission_rankings: carbonEmissionRankings,
                carbon_reduction_rankings: carbonReductionRankings
            } = response.data;

            return {
                mileageRanking: mileageRankings.map((item) => ({
                    vehicleId: item.car_id,
                    mileage: parseFloat(item.value),
                })),

                emissionsRanking: carbonEmissionRankings.map((item) => ({
                    vehicleId: item.car_id,
                    emissions: parseFloat(item.value),
                })),

                reductionPercentage: carbonReductionRankings.map((item) => ({
                    vehicleId: item.car_id,
                    current: parseFloat(item.current_reduction),
                    previous: parseFloat(item.previous_reduction),
                }))
            };
        } catch (error) {
            console.error('Error fetching new rankings:', error);
            throw new Error('無法連接到新的排名服務');
        }
    }

    async fetchStats() {
        try {
            const response = await apiClient.get('/api/CarbonEmission/stats');
            if (response.data.code === 0 && response.data.success) {
                return response.data.data;
            }
            throw new Error(response.data.message || '獲取碳排放統計數據失敗');
        } catch (error) {
            console.error('Error fetching carbon emission stats:', error);
            throw new Error('無法連接到碳排放統計服務');
        }
    }
}